export default function () {
  const button = document.getElementById('c-skip-main');

  if (!button) {
    return;
  }

  // começa escondido
  button.style.opacity = '0';
  button.style.pointerEvents = 'none';

  // mostrou teclado (TAB)
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Tab') {
      button.style.opacity = '1';
      button.style.pointerEvents = 'auto';
    }
  });

  // clicou mouse -> esconde
  document.addEventListener('mousedown', () => {
    button.style.opacity = '0';
    button.style.pointerEvents = 'none';
  });

  function firstInteractiveElement() {
    const elements = document.querySelectorAll(`main a, main input, main select, main button:not(.c-skip-main), main textarea, main [role="button"], main .wpcf7-list-item-label, footer a, footer input, footer select, footer button, footer textarea`);

    for (const item of elements) {
      const tabindex = item.getAttribute('tabindex');
      const isHidden = item.offsetParent === null;

      if (
        parseInt(tabindex, 10) === -1
        || item.getAttribute('type') === 'hidden'
        || isHidden
      ) {
        continue;
      }

      return item;
    }

    return null;
  }

  function scrollToContent() {
    const el = firstInteractiveElement();

    if (el) {
      el.focus();
    }

    button.style.opacity = '0';
    button.style.pointerEvents = 'none';
  }

  button.addEventListener('keydown', (event) => {
    if (event.key === 'Enter') {
      scrollToContent();
    }
  });
}